/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import ProductListQuery from 'Query/ProductList.query';
import { showNotification } from 'Store/Notification/Notification.action';
// import { prepareQuery } from 'Util/Query';
import { fetchQuery } from 'Util/Request/Query';

// import { executeGet } from 'Util/Request/Request';
import { updateDailyProductPromo } from './DailyProductPromo.action';

export const cacheLifetime = 86400;

/** @namespace Satisfly/Store/DailyProductPromo/Dispatcher */
export class DailyProductPromoDispatcher {
    getDailyProductPromo(dispatch) {
        return fetchQuery(ProductListQuery.getDailyProductPromo())
            .then(
            /** @namespace Satisfly/Store/DailyProductPromo/Dispatcher/DailyProductPromoDispatcher/getDailyProductPromo/then/catch/fetchQuery/then/dispatch */
                ({ getDailyProductPromo }) => dispatch(updateDailyProductPromo(getDailyProductPromo))
            )
            .catch(
            /** @namespace Satisfly/Store/DailyProductPromo/Dispatcher/DailyProductPromoDispatcher/getDailyProductPromo/then/catch/showNotification */
                () => showNotification('error', __('Error fetching daily product promotion'))
            );
    }
}

export default new DailyProductPromoDispatcher();
